<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import NotLoggedLayout from "./layout/not-logged-layout.vue";
import LoggedLayout from "./layout/logged-layout.vue";
export let route = useRouter();
export default {
  name: "App",
  components: {
    NotLoggedLayout,
    LoggedLayout,
  },
  setup() {
    let content = ref("");
    const store = useStore();
    const authObj = computed(() => store.state.auth.authData);
    const currentSession = authObj.value;
    const isLogged = computed(() => store.state.auth.loggedIn);
    route = useRouter();

    document.title = process.env.VUE_APP_CLIENT_NAME;
    const layout = computed(() => {
      return route.currentRoute.value.meta.layout;
    });

    return {
      currentSession,
      isLogged,
      route,
      content,
      layout,
    };
  },
  watch: {
    currentSession(value) {
      if (value == "") {
        route.push({ name: "login" });
      }
    },
  },
};
</script>

<!--<style>
@import "@/assets/styles/style.css";
</style> -->
